import { createWrapSafe } from '@/scopes/toolkit/createWrapSafe.js';

export const createWrapBasic = createWrapSafe;